import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import MailIcon from "@mui/icons-material/Mail";
import { useTranslation } from "react-i18next";
const CountingConfirmation = ({ CText,handleClose , handleSubmit, isDisabled}) => {
  const {t}=useTranslation()
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.81)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "#fff",
          borderRadius: "18px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          width: "90%",
          maxWidth: "380px",
          textAlign: "center",
          overflowY: "auto",
          maxHeight: "70%",
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <CloseIcon style={{ fontSize: "30px" }} />
        </button>
        <MailIcon
          style={{
            fontSize: "30px",
            color: "#3CB043",
            margin: "40px 30px 0",
          }}
        />
        <p
          style={{
            fontSize: "17px",
            color: "#333",
            lineHeight: "27px",
            fontWeight: "300",
            padding: "0 35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {CText} 
        </p>
        <div style={{display:'flex',justifyContent:'between',alignItems:'center' , padding:'20px', gap:'20px' }}>

        <button
          onClick={handleSubmit}
          style={{
            background: "none",
            border: "none",
            width: "100%",
            fontSize: "18px",
            height: "50px",
            borderRadius:'10px',
            backgroundColor: isDisabled ? "#B0B0B0" : "#3CB043",
            color: isDisabled ? "black" : "#FFFFFF",
            cursor: isDisabled ? "not-allowed" : "pointer",
            opacity: isDisabled ? 0.6 : 1,
          }}
          disabled={isDisabled}
        >
          {t('send')}
        </button>
        <button
          onClick={handleClose}
          style={{
            background: "none",
            border: "none",
            width: "100%",
            fontSize: "18px",
            cursor: "pointer",
            height: "50px",
            backgroundColor: "#052660",
            color: "#fff",
            borderRadius:'10px'
          }}
        >
          {t('close')}
        </button>
        </div>
      </div>
    </div>
  );
};
export default CountingConfirmation;